import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { InitialsPipe } from '@dxp/core/pipes';
import {
    ContactIconSize,
    ContactIconSizes,
    ContactIconUser,
    ContactIconUserTypes,
    UnknownCustomer,
} from '@dxp/core/types';

/**
 * @deprecated Use <telxl-avatar> instead
 */
@Component({
    selector: 'telxl-contact-icon',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InitialsPipe],
    templateUrl: './contact-icon.component.html',
    styleUrl: './contact-icon.component.scss',
})
export class ContactIconComponent {
    fullName = input.required<string>();
    size = input<ContactIconSize>(ContactIconSizes.Small);
    contactType = input<ContactIconUser>(ContactIconUserTypes.Default);

    mappedContactType = computed(() => {
        const allowedContactTypes = Object.values(ContactIconUserTypes).some(
            allowedUserTypes => allowedUserTypes === this.contactType(),
        );
        return !this.contactType() ||
            !allowedContactTypes ||
            this.fullName() === UnknownCustomer
            ? ContactIconUserTypes.Unknown
            : this.contactType().toLowerCase();
    });

    mappedSize = computed(() => {
        const allowedContactTypes = Object.values(ContactIconSizes).some(
            allowedUserTypes => allowedUserTypes === this.size(),
        );
        return !this.size() || !allowedContactTypes
            ? ContactIconSizes.Small
            : this.size().toLowerCase();
    });

    cssClass = computed(() => [
        `contact-icon__theme--${this.mappedContactType()}`,
        `contact-icon__size--${this.mappedSize()}`,
    ]);
}
